import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { Accessor } from "./Accessor";

var get = require("lodash/get");

export var SuggestionsAccessor =
/*#__PURE__*/
function (_Accessor) {
  _inherits(SuggestionsAccessor, _Accessor);

  function SuggestionsAccessor(field) {
    var _this;

    _classCallCheck(this, SuggestionsAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SuggestionsAccessor).call(this));
    _this.field = field;
    return _this;
  }

  _createClass(SuggestionsAccessor, [{
    key: "getSuggestion",
    value: function getSuggestion() {
      return get(this.searchkit.getSuggestions(), [0, "options", 0, "text"], false);
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      var queryText = query.getQueryString();

      if (queryText.length > 3) {
        return query.setSuggestions({
          text: queryText,
          suggestions: {
            phrase: {
              field: this.field,
              real_word_error_likelihood: 0.95,
              max_errors: 1,
              gram_size: 4,
              direct_generator: [{
                field: this.field,
                suggest_mode: "always",
                min_word_length: 1
              }]
            }
          }
        });
      }

      return query;
    }
  }]);

  return SuggestionsAccessor;
}(Accessor);